import { AssetManager, Button, DialogHandler, Dropdown, DropMenu, EAssetManagerMatchType, Icon, TagsFactory, TAssetManagerOption, TGenericListReturn, TTag } from "@cakemail-org/ui-components-v2"
import { TAddTagsButton } from "./types"
import { ChangeEvent, useEffect, useState } from "react"
import { Box } from "@mui/material"
import { useTranslation } from "react-i18next"
import "./styles.scss"
import { TButtonRef } from "@cakemail-org/ui-components-v2/dist/esm/components/button/types"


export function AddTagsButton({ disabled, tagList, multiTagList, onTag, onUntag }: TAddTagsButton) {
    const { t } = useTranslation()
    const [showMenu, setShowMenu] = useState(false)
    const [search, setSearch] = useState("")
    const [tags, setTags] = useState<TTag[]>([])
    const [filteredTags, setFilteredTags] = useState<TTag[]>([])

    useEffect(() => {
        fetchTags()
    }, [])

    useEffect(() => {
        setFilteredTags(filterTags(tags, search))
    }, [search, tags])

    function fetchTags() {
        TagsFactory.list({ perPage: 500 }).then((data: TGenericListReturn<TTag>) => {
            setTags(data.data)
        })
    }

    function handleShowMenu() {
        setShowMenu(!showMenu)
    }

    function handleSearchChange(event: ChangeEvent<HTMLInputElement>) {
        const filteredStr = event.currentTarget.value.replace(
            /[^A-Za-z0-9.\-+_]+/g,
            ""
        )
        setSearch(filteredStr)
    }

    function handleCreateAction(event: React.MouseEvent<HTMLButtonElement>, btnRef: TButtonRef, option: TAssetManagerOption) {
        TagsFactory.create({
            tag: search
        }).then((data) => {
            btnRef?.reset()
            setSearch("")
            setTags([...tags, data])
        }).catch(() => {
            DialogHandler.show({
                type: "error",
                title: t("general-error-action"),
            })
            btnRef?.reset()
        })
    }

    function handlePrimaryAction(event: React.MouseEvent<HTMLButtonElement>, btnRef: TButtonRef, option: TAssetManagerOption) {
        onTag(option.value, btnRef)
    }

    function handleSecondaryAction(event: React.MouseEvent<HTMLButtonElement>, btnRef: TButtonRef, option: TAssetManagerOption) {
        onUntag(option.value, btnRef)
    }

    function filterTags(tags: TTag[], search: string) {
        let filteredTags = tags.filter((tag) => tag.tag.includes(search))
        if (filteredTags.length > 50) {
            filteredTags = filteredTags.slice(0, 50)
        }
        return filteredTags
    }

    let searchFullMatch = false

    const options: (TAssetManagerOption & { new?: boolean })[] = filteredTags?.map((tagObj) => {
        const tag = tagObj.tag
        let matchType = undefined

        if (!searchFullMatch) {
            searchFullMatch = tag === search
        }

        if (tagList && tagList.includes(tag)) {
            matchType = EAssetManagerMatchType.full
        }

        // TODO Multi resource tags to build partial match

        return {
            text: tag,
            value: tag,
            matchType: matchType,
        }
    })

    if ((options.length === 0 || !searchFullMatch) && search?.trim() !== "") {
        options.unshift({ text: search, value: search, new: true } as TAssetManagerOption & { new?: boolean })
    }

    return <Box className="addTagsButton">

        <Button
            iconOnly
            variant="outlined"
            color="body1"
            onClick={handleShowMenu}
            disabled={disabled}
        >
            <Icon name="Tag18" />
        </Button>

        {showMenu &&
            <AssetManager
                options={options}
                chooseAssetTitle={t("tags-choose-tag-title")}
                textFieldProps={{
                    value: search,
                    placeholder: t("tags-search-placeholder"),
                    onChange: handleSearchChange,
                }}
                createBtnProps={{
                    text: t("general-create"),
                    onClick: handleCreateAction
                }}
                listMainBtn={{
                    text: t("general-tag_one"),
                    onClick: handlePrimaryAction
                }}
                listSecondaryBtn={{
                    text: t("general-untag"),
                    onClick: handleSecondaryAction
                }}
                manageBtn={{
                    text: t("general-close"),
                    onClick: handleShowMenu
                }}
            />
        }
    </Box>


}